import { Controller } from 'react-hook-form';
import { QuestionmarkSmallCircleFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { Spacing, Tooltip } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { OperationType } from '../../../../../types';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../../types';
import { PlanNotiText } from '../PlanDurationSelector/shared';
import { MaxCcuQuantityInput } from './MaxCcuQuantityInput';
export const BasicPlanTabsContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    currentPlanMaxCcu,
    currentOperationType,
    isUpdate
  } = usePlanPaymentInfoContext();
  const {
    control,
    getValues,
    watch
  } = usePlanPaymentFormContext();
  const planTemplateType = watch('planTemplateType');
  const min = currentOperationType === OperationType.일시납 && currentPlanMaxCcu || 20;
  return <>
      <div className="flex h-4xl w-full items-center rounded-[10px] border border-gray-200 bg-white pl-[26px] pr-[24px]">
        <div className="flex items-center gap-3xs">
          <span className="text-body-2-sb text-[14px] font-semibold text-gray-900">
            {t('subscription:payment.planSelect.CCU', '최대 동시 접속 인원')}
          </span>
          <Tooltip tooltipClassName="w-[300px]" title={t('subscription:payment.planSelect.tooltip', '스페이스에 동시 접속할 수 있는 최대 인원수입니다. 인원 수는 10인 단위로만 입력 가능합니다.')} placement={'top'} data-sentry-element="Tooltip" data-sentry-source-file="BasicPlanTabsContent.tsx">
            <QuestionmarkSmallCircleFillIcon width={14} height={14} fill={Colors.Gray500} data-sentry-element="QuestionmarkSmallCircleFillIcon" data-sentry-source-file="BasicPlanTabsContent.tsx" />
          </Tooltip>
        </div>
        <div className="ml-auto">
          <Controller control={control} name="maxCcu" defaultValue={getValues('maxCcu')} render={({
          field
        }) => <MaxCcuQuantityInput min={min} initialValue={field.value} onChange={value => {
          if (value % 10 === 0) {
            field.onChange(value);
          }
        }} />} data-sentry-element="Controller" data-sentry-source-file="BasicPlanTabsContent.tsx" />
        </div>
      </div>
      {isUpdate && planTemplateType === PlanTemplateType.PRODUCT_ONETIME && <>
          <Spacing size={14} />
          <PlanNotiText alertText={t('subscription:payment.planTabs.alertUpgradeOnetime', '결제된 기간 동안은 플랜 또는 인원 수를 낮출 수 없습니다')} />
        </>}
    </>;
};